import {
  cacheImageDataUrl,
  convertBase64ToDataUrl
} from '@/services/tierImageService';
import {COUNTRY_LANGUAGES_CODES} from '@/utils/constants/globalConstants';

export function transformTierDataToForm(
  tierData,
  formatMessage,
  countryCode = 'MX'
) {
  const formData = {
    name: tierData.name || '',
    tierId: String(tierData.tierID || tierData.tierId || ''),
    activities:
      tierData.activities?.map((activity) => ({
        activityID: String(activity.activityID || ''),
        activityName: activity.activityName,
        multiplier: activity.multiplier
      })) || [],
    content: {}
  };

  const languages = COUNTRY_LANGUAGES_CODES[countryCode] || [];
  const expectedLanguages = languages.map((lang) => lang.code);

  expectedLanguages.forEach((langCode) => {
    formData.content[langCode] = {
      tierName: tierData.name || '',
      displayDescription: '',
      imageTierIcon: '',
      imageTierIconObject: null,
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      bannerImageObject: null,
      detailsDescription: '',
      detailsTermsAndConditions: '',
      detailsImage: '',
      detailsImageObject: null
    };
  });

  if (tierData.content && Object.keys(tierData.content).length > 0) {
    Object.keys(tierData.content).forEach((langKey) => {
      if (!expectedLanguages.includes(langKey)) {
        return;
      }

      const content = tierData.content[langKey];
      if (
        content.imageTierIconObject?.id &&
        content.imageTierIconObject?.data
      ) {
        const dataUrl = convertBase64ToDataUrl(
          content.imageTierIconObject.data
        );
        cacheImageDataUrl(content.imageTierIconObject.id, dataUrl);
      }
      if (content.bannerImageObject?.id && content.bannerImageObject?.data) {
        const dataUrl = convertBase64ToDataUrl(content.bannerImageObject.data);
        cacheImageDataUrl(content.bannerImageObject.id, dataUrl);
      }
      if (content.detailsImageObject?.id && content.detailsImageObject?.data) {
        const dataUrl = convertBase64ToDataUrl(content.detailsImageObject.data);
        cacheImageDataUrl(content.detailsImageObject.id, dataUrl);
      }
      formData.content[langKey] = {
        tierName: content.tierName || tierData.name || '',
        displayDescription: content.displayDescription || '',
        imageTierIcon:
          content.imageTierIconObject?.id || content.imageTierIcon || '',
        imageTierIconObject: content.imageTierIconObject || null,
        bannerHeader: content.bannerHeader || '',
        bannerDescription: content.bannerDescription || '',
        bannerImage: content.bannerImageObject?.id || content.bannerImage || '',
        bannerImageObject: content.bannerImageObject || null,
        detailsDescription: content.detailsDescription || '',
        detailsTermsAndConditions: content.detailsTermsAndConditions || '',
        detailsImage:
          content.detailsImageObject?.id || content.detailsImage || '',
        detailsImageObject: content.detailsImageObject || null
      };
    });
  }

  return formData;
}
